import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { formatMoney } from '../dateUtils';
import { categoryEmoji } from '../categoryEmoji';
import { getCachedData, refreshCache } from '../store';
import TemplateForm from './TemplateForm';
import TransactionForm from './TransactionForm';
import Modal from './Modal';

export default function Templates() {
  const [templates, setTemplates] = useState([]);
  const [categories, setCategories] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  // Шаблон, который применяем — открываем форму транзакции с заполненными полями
  const [useTemplate, setUseTemplate] = useState(null);

  const loadData = async () => {
    const temps = await api.getTemplates();
    const cats = await api.getCategories();
    const accs = await api.getAccounts();
    setTemplates(temps);
    setCategories(cats);
    setAccounts(accs);
  };

  useEffect(() => {
    const cached = getCachedData();
    if (cached) {
      if (Array.isArray(cached.templates)) setTemplates(cached.templates);
      if (Array.isArray(cached.categories)) setCategories(cached.categories);
      if (Array.isArray(cached.accounts)) setAccounts(cached.accounts);
    }
    loadData();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Удалить шаблон?')) {
      await api.deleteTemplate(id);
      loadData();
      refreshCache();
    }
  };

  const getCategoryName = (categoryId) => {
    const cat = categories.find(c => c.id === categoryId);
    return cat ? cat.name : '—';
  };

  const getAccountName = (accountId) => {
    const acc = accounts.find(a => String(a.id) === String(accountId));
    return acc ? acc.name : '';
  };

  return (
    <div className="content">
      <h1>Шаблоны</h1>
      <button style={{ marginBottom: '14px' }} onClick={() => { setShowForm(true); setEditingTemplate(null); }}>+ Новый шаблон</button>
      {showForm && (
        <TemplateForm
          template={editingTemplate}
          categories={categories}
          accounts={accounts}
          onSave={async (data) => {
            if (editingTemplate) {
              await api.updateTemplate(editingTemplate.id, data);
            } else {
              await api.createTemplate(data);
            }
            setShowForm(false);
            loadData();
            refreshCache();
          }}
          onCancel={() => setShowForm(false)}
        />
      )}
      <ul className="list">
        {templates.map(t => (
          <li key={t.id} className="list-item template-item" onClick={() => setUseTemplate(t)}>
            <div className="list-item-left">
              <span className="cat-icon">{categoryEmoji(getCategoryName(t.categoryId))}</span>
              <div>
                <div className="list-item-title">
                  {t.type === 'expense' ? 'Расход' : 'Доход'}: {getCategoryName(t.categoryId)}
                </div>
                <div className="list-item-sub">{t.amount != null ? formatMoney(t.amount) : 'Сумма не задана'}{t.accountId ? ` · ${getAccountName(t.accountId)}` : ''}{t.description ? ` · ${t.description}` : ''}</div>
              </div>
            </div>
            <div className="actions" onClick={(e) => e.stopPropagation()}>
              <button className="small-icon" title="Редактировать" onClick={() => { setEditingTemplate(t); setShowForm(true); }}>✏️</button>
              <button className="small-icon danger" title="Удалить" onClick={() => handleDelete(t.id)}>🗑️</button>
            </div>
          </li>
        ))}
      </ul>

      {useTemplate && (
        <Modal title="Новая операция из шаблона" onClose={() => setUseTemplate(null)}>
          <TransactionForm
            categories={categories}
            transaction={{
              type: useTemplate.type,
              categoryId: useTemplate.categoryId,
              accountId: useTemplate.accountId || undefined,
              amount: useTemplate.amount,
              description: useTemplate.description || '',
            }}
            onSave={async (data) => {
              await api.createTransaction(data);
              setUseTemplate(null);
              refreshCache();
            }}
            onCancel={() => setUseTemplate(null)}
          />
        </Modal>
      )}
    </div>
  );
}
